import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import branch from 'client/core/branch';

import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import {
  SR_BUTTON_THEME_ADOBE_BLUE,
  SR_BUTTON_THEME_ADOBE_BLUE_INVERTED,
} from 'client/components/SrButton/SrButton';

import SrBox from 'client/components/SrBox';
import './SrPhotosModal.less';

@branch({
  appUrl: ['env', 'APP_URL'],
})
class SrPhotosModal extends Component {
  static propTypes = {
    photos: PropTypes.array.isRequired,
    partner: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    listing: PropTypes.object,
    downloadDisabled: PropTypes.bool,
  };

  _downloadPhotos = () => {
    if (this.props.downloadDisabled) {
      return;
    }

    const stringQuery = JSON.stringify({
      listingId: this.props.listing.id,
    });
    const encodedQuery = encodeURIComponent(stringQuery);
    const downloadDocumentsUrl = `${this.props.appUrl}/bundle-files/all-photos?data=${encodedQuery}`;
    global.open(downloadDocumentsUrl);
  };

  _goToEditPhotosPage = () => {
    const { listing } = this.props;
    const listingId = listing.id;
    const currentUrl = global.location.href;
    const url = `/listing/${listingId}/photos?enableEditing=true&backUrl=${encodeURIComponent(
      currentUrl,
    )}`;

    global.location.href = url;
  };

  _getButtonProps = () => {
    const { partner, downloadDisabled } = this.props;

    if (downloadDisabled) {
      return null;
    }

    const buttonProps = [
      {
        text: 'Download Photos',
        theme: SR_BUTTON_THEME_ADOBE_BLUE,
        onClick: () => this._downloadPhotos(),
        minWidth: '100%',
      },
    ];

    if (partner?.experienceConfiguration?.photoSortingEnabled) {
      buttonProps.push({
        text: 'Sort Photos',
        theme: SR_BUTTON_THEME_ADOBE_BLUE_INVERTED,
        onClick: () => {
          this.props.onClose();
          this._goToEditPhotosPage();
        },
        minWidth: '100%',
        margin: '10px 0px 0px',
      });
    }

    return buttonProps;
  };

  render() {
    const { photos, onClose } = this.props;

    const buttonProps = this._getButtonProps();

    return (
      <SrModalV2
        contentMaxWidth="1030px"
        theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
        closeOnBackgroundClick
        onClose={onClose}
        buttonTheme={SR_BUTTON_THEME_ADOBE_BLUE}
        contentPadding="28px 0px 120px"
        buttonProps={buttonProps}
        buttonContainerProps={{
          flexDirection: 'column',
        }}
      >
        <SrBox styleName={classNames('SrPhotosModal')}>
          <div style={{}} styleName={classNames('photosContainer')} className="">
            {photos.map((photoUrl, index) => (
              <div key={photoUrl} styleName={classNames('listingPhoto')}>
                <img src={photoUrl} alt={index} />
                <br />
              </div>
            ))}
          </div>
        </SrBox>
      </SrModalV2>
    );
  }
}

SrPhotosModal.displayName = 'SrPhotosModal';

export default SrPhotosModal;
